import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import classNames from 'classnames';
import { groundsDispatch } from './utils';
import styles from './index.css';
import { BASE_PATH } from '@src/mobile/constants';
import { getAnalyzeLink } from '@src/mobile/indexheader/layout/services';
import { isGrounds } from '@src/mobile/utils/app';
import { getDispatchAction } from '@src/mobile/utils/url';

const Link = ({ children, target, className = '', style = {}, url }) => {
    if (window.grounds && window.grounds.dispatch) {
        const handleSpanClick = async () => {
            const res = await getAnalyzeLink(url);
            const ucmsType = res?.data?.data?.doc?.type;
            const base62Id = res?.data?.data?.base62;
            const [type = 'web', to] = getDispatchAction(url, ucmsType, base62Id, isGrounds);

            groundsDispatch({ to, type });
        };

        return (
            <span onClick={handleSpanClick} className={classNames(styles.span, className)} style={style}>
                {children}
            </span>
        );
    } else {
        return (
            <a href={url} {...(target ? { target } : {})} className={classNames(styles.a, className)} style={style}>
                {children}
            </a>
        );
    }
};

Link.propTypes = {
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.array]),
    url: PropTypes.string,
    type: PropTypes.string,
    target: PropTypes.string,
    className: PropTypes.string,
    style: PropTypes.object,
    needLinkAnalyze: PropTypes.bool,
};

export const linkBase = `${window.location.origin}${BASE_PATH}`;

export default errorBoundary(Link);
